import {
  Container,
  Typography,
  Box,
  Stack,
  Alert,
  AlertTitle,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/common/Header";
import SubmitButton from "../components/common/SubmitButton";
import SittingAnimation from "../components/Lottie/SittingAnimation";
//import LoanAmountCard from '../components/Cards/LoanAmountCard';
import configData from "../Config";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "../Style/Modules/eligibleAmount.module.css";
import "../Style/Theme/index.css";
import Backdrop from "../components/common/Backdrop";
import LoadingDots from "../components/Lottie/LoadingDots";
import { apis } from "../services/apiService";
import AlertPopup from "../components/common/AlertPopup";
import useSelector from "../store/selector";
import { constant, decryptData } from "../utils/utils";
export default function EligibleAmount() {
  const navigate = useNavigate();
  let location = useLocation();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [finalErr, setFinalErr] = useState("");
  const { getRecoilVal, setRecoilVal } = useSelector();
  let IsSalesApprovedForBRE = parseInt(location?.state?.IsSalesApprovedForBRE)
    ? parseInt(location?.state?.IsSalesApprovedForBRE)
    : "";

  let eligibleAmountRecoil = parseInt(location.state.ALimit);
  const handleClick = (e) => {
    let data = { AppId: location?.state?.AppId };
    navigate("/upload-income-proof", { state: data });
  };
  let handleSubmit = async (e) => {
    e.preventDefault();
    let getPreUserDatafromRecoil = getRecoilVal(constant.atomsName.USER_DETAIL);

    const getDecryptedProgrameName = await decryptData(
      getPreUserDatafromRecoil?.program
    );
    if (
      getDecryptedProgrameName === "Agrostar_RF" &&
      // eligibleAmountRecoil > 1000000 &&
      IsSalesApprovedForBRE === 1
    ) {
      navigate("/error", {
        state: {
          AppId: location.state.AppId,
          H: "Journey Paused",
          Disc: "You have to wait for sales approval.",
          // otherMSG:
          //   "Please contact at phone - 9999999999 or email - support@tyger.com",
        },
      });
    } else if (
      getDecryptedProgrameName === "Agrostar_RF" &&
      // eligibleAmountRecoil > 1000000 &&
      IsSalesApprovedForBRE === 3
    ) {
      navigate("/error", {
        state: {
          AppId: location.state.AppId,
          H: "Journey Rejected",
          Disc: "Your Journey is rejected",
          // otherMSG:
          //   "Please contact at phone - 9999999999 or email - support@tyger.com",
        },
      });
    } else {
      try {
        setLoading(true);
        if (location.state.ALimit > 0) {
          const reqData = {
            aid: location.state.AppId,
            amt: parseInt(location.state.ALimit),
          };
          let resp = await apis.postApi(
            configData.API_URL + "Aggrement/AddLimit",
            // "https://axiomuat.adanicapital.in/application/api/ApplicationFlow/AddLimit",
            reqData
          );
          let result = await resp.json();
          if (resp?.status === 200) {
            setLoading(false);
            let data = {
              AppId: location.state.AppId,
              A: result?.data[0],
              B: result?.data[1],
              C: result?.data[2],
              R: result?.data[3],
            };
            navigate("/terms-and-conditions", { state: data });
          }
        } else
          navigate("/error", {
            state: {
              AppId: location.state.AppId,
              H: "Sorry!!",
              Disc: "We regret to inform you that no limit has been assigned to you on the basis of your details shared with us",
            },
          });

        setLoading(false);
      } catch (error) {
        setLoading(false);
        const errorResult = JSON.parse(error?.message);
        setFinalErr(errorResult?.statusMessage);
        //console.log(err);
      }
    }
  };

  const handleClosedFunk = () => {
    setFinalErr("");
  };

  // useEffect(() => {
  //   if (location?.state?.Status === "REJECTED") {
  //     navigate("/error", {
  //       state: {
  //         AppId: location.state.AppId,
  //         H: "Sorry!!",
  //         Disc: "Rejected by BRE",
  //       },
  //     });
  //   }
  // }, []);

  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} step={9} />
        <Box sx={{ paddingBottom: "100px" }}>
          <Box py={5} className={styles.eligibleAmountBox}>
            <SittingAnimation />
            <Box className={styles.eligibleAmountBox4}>
              <Typography
                variant="h1"
                sx={{ my: 2, textAlign: "center", color: "#1D1E24", mx: 5 }}
              >
                {parseInt(location.state.ALimit) > 0
                  ? t("Congratulations! You are eligible for a loan of")
                  : t(
                      "Sorry! We regret to inform you that you are not eligible for loan."
                    )}
              </Typography>
              <Typography
                color="info"
                sx={{
                  textAlign: "center",
                  color: "#0D1C6E",
                  fontSize: "32px",
                  fontWeight: "bold",
                }}
              >
                {t("₹")}
                {location.state.ALimit.toString().replace(
                  /\B(?=(\d{3})+(?!\d))/g,
                  ","
                )}
              </Typography>
            </Box>
          </Box>
          {parseInt(location.state.ALimit) !== 1000000 && (
            <Box className={styles.eligibleAmountBox1}>
              <Box className={styles.eligibleAmountBox2}>
                <Typography
                  variant="h1"
                  sx={{ mb: 2, textAlign: "start", color: "#1D1E24" }}
                >
                  {"You can Increase your loan amount!"}
                </Typography>
                <Typography
                  color="subtitle"
                  sx={{
                    color: "#828D9C",
                    fontWeight: "500",
                  }}
                >
                  {
                    "By submitting a few more documents, you can get a higher loan amount."
                  }
                </Typography>
              </Box>
              <Box className={styles.eligibleAmountBox3}>
                <img src="/assets/next.svg" alt="next" onClick={handleClick} />
              </Box>
            </Box>
          )}
        </Box>
        <form onSubmit={handleSubmit}>
          {location.state.ALimit > 0 && <SubmitButton hasNote="No" />}
        </form>
        {finalErr && (
          <Backdrop ax="center">
            <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />;
          </Backdrop>
        )}
        {loading && (
          <Backdrop ax="center">
            <LoadingDots />
          </Backdrop>
        )}
      </Container>
    </>
  );
}
